<!-- eslint-disable no-console -->
<template>
  <div>
    <b-modal no-close-on-backdrop no-close-on-esc v-model="show" size="md" header-class="my-class"
        ref="modal-inser-user" title-class="font-18">
      <template #modal-header="{ close }" class="bg-dark">
        <!-- Emulate built in modal header close button action -->
        <p class="w-100 pt-3 text-center text-white h-100" size="sm" disabled variant="outline-danger">
          {{ titleModalAdd }}
        </p>
      </template>
      <div class="row" v-if="step === 1">
        <label v-if="file === ''" style="cursor: pointer">
          <vue2Dropzone id="vue2Dropzone" :use-custom-slot="true" :options="dropzoneOptions">
            <div class="dropzone-custom-content">
              <i class="display-4 text-muted bx bxs-cloud-upload"></i>
              <h4 style="color: #d3d3d3 !important; font-weight: 700 !important;"> 動画をここにアップロードしてください </h4>
              <p>
                <span onclick="javascript:void(0)" type="button"
                    class="font-size-14 btn-lyg w-lg rounded mt-3 p-2">選択</span>
              </p>
            </div>
          </vue2Dropzone>
          <input style="display: none" type="file" accept="video/mp4" @change="selectFile($event)"/>
        </label>
      </div>
      <div class="row justify-content-center" v-show="step === 2 || step === 3">
        <video height="400" style="margin-bottom: -2.5rem !important" @canplay="updatePaused"
            id="video-preview" type="video/mp4" autoplay :controls="control" v-show="file != ''"/>
        <div class="row mt-lg-5 text-center" v-show="file != '' && step === 2">
          <p class="mb-0">サムネイルを作成するために、</p>
          <p class="mb-0">適切な瞬間をスクリーンショットしてください。</p>
        </div>
      </div>
      <div class="row text-center mt-lg-5" v-show="step === 3 && file != ''">
        <p class="mb-0">この写真をサムネイルにして進む、</p>
        <p class="mb-0">または、もう一度スクリーンショットしてください。</p>
      </div>
      <div class="row mt-2" v-if="step == 4">
        <div class="col-4 text-center">
          <img :src="imgSrc" alt="" style="width: 100%; height: auto;"/>
        </div>
        <div class="col-8">
          <b-form-group class="" label-for="name">
            <label class="text-label">
              テロップ１ <span
                class="text-label-required bg-required-label badge badge-soft-danger font-size-11 me-2">必須</span>
            </label>
            <b-form-input v-model.trim="video.name" for="name" type="text" placeholder="テロップ１"
              @input="clearError('name', video.name)" />
            <div class="text-danger" v-if="errors.name">{{ errors.name }}</div>
          </b-form-group>
        </div>
        <div class="col-12 mt-2">
          <b-form-group class="mb-3" label-for="caption">
            <label class="text-label">テロップ２</label>
            <b-form-input v-model.trim="video.caption" for="caption" type="text" placeholder="テロップ２"/>
          </b-form-group>
        </div>
        <div class="col-6 mt-2">
          <b-form-group class="mb-3" label-for="met">
            <label class="text-label">MET’ｓ換算</label>
            <b-form-input v-model="video.met" for="met" type="text" placeholder="MET’ｓ換算"
              @input="clearError('met', video.met)" />
            <div class="text-danger" v-if="errors.met">{{ errors.met }}</div>
          </b-form-group>
        </div>
        <div class="col-6 mt-2">
          <b-form-group class="mb-3" label-for="duration">
            <label class="text-label">動画再生時間</label>
            <b-form-input :value="formatDuration(video.duration)" disabled for="code" type="text" placeholder="動画再生時間"/>
          </b-form-group>
        </div>
        <template v-for="category in categories">
          <div class="col-12 mt-2" v-if="category.id === 3" :key="category.id">
            <b-form-group class="mb-3">
              <h6 class="text-label">{{ category.name }} ({{ category.children.map(i => i.text).join(', ') }})</h6>
              <b-form-checkbox-group v-model="video.weekdays" :options="getJpWeekDayOptions()" class="weekday-option"/>
            </b-form-group>
          </div>
          <div class="col-12 mt-2" v-else :key="category.id">
            <b-form-group class="mb-3">
              <h6 class="text-label">{{ category.name }}</h6>
              <b-form-checkbox-group v-model="video.categories" :options="category.children"/>
            </b-form-group>
          </div>
        </template>
      </div>
      <template #modal-footer>
        <div class="w-100">
          <b-button @click="closeModal()" variant="outline-danger" style="margin-left: 5px" class="float-end w-lg">
            キャンセル
          </b-button>
          <b-button v-if="step === 2 && file != ''"
              @click="(file = ''), (imgSrc = null), (step = 1), (disableCapture = true)"
              variant="success" style="margin-left: 5px" class="float-end w-lg"> 再アップロード
          </b-button>
          <b-button v-if="step === 3 && imgSrc != ''" @click="(imgSrc = null), (step = 2), play(), (control = true)"
              variant="success" style="margin-left: 5px" class="float-end w-lg"> もう一度撮る
          </b-button>
          <b-button v-if="step === 2" :disabled="disableCapture" @click="capture(), (step = 3)" type="button"
              class="float-end btn-lyg w-lg btn-capture"> スクリーンショット
          </b-button>
          <b-button v-if="step === 3" @click="(step = 4)" type="button" class="float-end btn-lyg w-lg btn-capture">
            この写真を使用する
          </b-button>
          <b-button v-if="step === 4" @click="submit()"
              type="button" class="float-end btn-lyg w-lg btn-capture"> アップロード
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import { mixin } from '../../helpers/Vue-Mixin';
import vue2Dropzone from 'vue2-dropzone';
import api from '@/api';

export default {
  props: ['show'],

  data () {
    return {
      disableCapture: true,
      timerProgress: 60000,
      paused: null,
      control: true,
      videoElement: '',
      titleModalAdd: '動画アップロード',
      step: 1,
      file: '',
      imgSrc: null,
      dropzoneOptions: {
        uploadMultiple: false,
        // eslint-disable-next-line no-undef
        url: process.env.VUE_APP_API_ADMIN,
        thumbnailWidth: 150,
        maxFileSizeInMB: 200,
        autoProcessQueue: false,
      },
      video: this.blankVideo(),
      categories: [],
      errors: this.resetErrors(),
    }
  },

  components: { vue2Dropzone },

  mixins: [mixin],

  watch: {
    step: {
      handler (value) {
        switch (value) {
          case 1:
            this.titleModalAdd = '動画アップロード';
            break
          case 2:
            this.titleModalAdd = 'プレビュー・サムネイル作成';
            break
          case 3:
            this.titleModalAdd = 'スクリーンショット';
            break
          case 4:
            this.titleModalAdd = '動画情報';
            break
          default:
            break
        }
      },
    },
  },

  async created () {
    await this.getGroupedCategoryOptions();
  },

  methods: {

    blankVideo () {
      return {
        categories: [],
        name: '',
        caption: '',
        met: null,
        duration: null,
        path: null,
        thumbnail: null,
        weekdays: [],
        status: 1,
      }
    },

    resetErrors() {
      return {
        name: '',
        met: '',
      };
    },

    clearError(field, value) {
      if (value !== null && value !== '' && value !== undefined) {
        this.errors[field] = '';
      }
    },

    validated() {
      let valid = true;
      this.errors = this.resetErrors();

      if (this.video.name === null || this.video.name === '') {
        this.errors['name'] = 'テロップ１がりテストを選択してください';
        valid = false;
      }

      if (isNaN(Number(this.video.met))) {
        this.errors['met'] = '立ち上がりテストを選択してください';
        valid = false;
      }

      return valid;
    },

    async getGroupedCategoryOptions() {
      const res = await api.getCategories();
      const categories = res.data;
      this.categories = categories.map(i => {
        i.children = i.children.map(j => ({text: j.name, value: j.id}));
        return i;
      });
    },

    getJpWeekDayOptions() {
      return [
        {text: '月', value: 1},
        {text: '火', value: 2},
        {text: '水', value: 3},
        {text: '木', value: 4},
        {text: '金', value: 5},
      ];
    },

    closeModal () {
      this.step = 1;
      this.$emit('close');
    },

    resetData() {
      this.file = '';
      this.imgSrc = null;
      this.video = this.blankVideo();
      this.disableCapture = true;
      this.control = true;
    },

    selectFile (event) {
      this.file = event.target.files[0];
      this.previewVideo();
      this.step = 2;
    },

    updatePaused (event) {
      this.videoElement = event.target;
      this.paused = event.target.paused;
    },

    restartVideo () {
      this.videoElement.pause();
      this.videoElement.currentTime = 0;
      this.videoElement.load();
    },

    play () {
      this.videoElement.play();
    },

    pause () {
      this.videoElement.pause();
    },

    async submit () {
      if (!this.validated()) {
        return;
      }

      this.closeModal();
      this.uploadVideoMixin(this.timerProgress);

      try {
        await this.uploadVideo();
        await api.createVideo(this.video);
        window.toastr.success("動画アップロード が完了しました。");
        this.$emit('added');
      } catch (error) {
        // eslint-disable-next-line no-console
        window.toastr.error("動画が長すぎます");
        console.error(error);
      } finally {
        this.resetData();
        const loading = document.getElementsByClassName("swal2-confirm");
        if (loading.length > 0) {
          loading[0].click();
        }
      }
    },

    capture () {
      let videoCanvas = document.createElement('canvas');
      let videoEl = document.getElementById('video-preview');
      videoCanvas.height = videoEl.videoHeight;
      videoCanvas.width = videoEl.videoWidth;
      videoCanvas.getContext('2d').drawImage(videoEl, 0, 0);
      this.imgSrc = videoCanvas.toDataURL('image/png');
      this.video.duration = Math.floor(videoEl.duration);
      this.pause();
      this.control = false;
    },

    formatDuration(duration) {
      return `${Math.floor(duration / 60)}:${Math.floor(duration % 60)}`;
    },

    dataURLtoFile (dataUrl, filename) {
      let arr = dataUrl.split(','),
          mime = arr[0].match(/:(.*?);/)[1],
          bstr = atob(arr[arr.length - 1]),
          n = bstr.length,
          u8arr = new Uint8Array(n);

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }

      return new File([u8arr], filename, { type: mime });
    },

    previewVideo () {
      let video = document.getElementById('video-preview');
      let reader = new FileReader();
      reader.readAsDataURL(this.file);
      reader.addEventListener('load',  () => {
        video.src = reader.result;
      });

      video.addEventListener('loadedmetadata', () => {
        // eslint-disable-next-line no-console
        this.disableCapture = false;
      })
    },

    pathInfo(fullPath) {
      const parsed = fullPath.match(/(.*?[\\/:])?(([^\\/:]*?)(\.[^\\/.]+?)?)(?:[?#].*)?$/);

      return {
        path: parsed[1],
        file: parsed[2],
        name: parsed[3],
        ext: parsed[4] ? parsed[4].replace('.', '') : undefined
      };
    },

    generatePaths(fullPath) {
      let {name: videoName, ext: videoExt} = this.pathInfo(fullPath);

      videoName += `-${Date.now()}`;

      return {
        video: `recommend-videos/${videoName}.${videoExt}`,
        thumbnail: `thumbnails/${videoName}.png`
      };
    },

    async uploadVideo () {
      const {video: videoPath, thumbnail: thumbnailPath} = this.generatePaths(this.file.name);

      const [path, thumbnail] = await Promise.all([
        await api.uploadFile(videoPath, this.file),
        await api.uploadFile(thumbnailPath, this.dataURLtoFile(this.imgSrc, 'tmp.png')),
      ]);

      this.video.path = path;
      this.video.thumbnail = thumbnail;
    },
  },
}
</script>

<style scoped>
::v-deep .my-class {
  background: #395299;
  color: white;
  font-weight: 700;
  color: #ffffff;
  font-size: 20px;
  height: 70px;
  line-height: 18px;
}

::v-deep .custom-control-label {
  margin-left: 1.25em;
}

.disabled {
  pointer-events: none;
  cursor: default;
}

::v-deep .custom-control-inline {
  display: inline-block;
  width: 150px;
}

::v-deep .weekday-option .custom-control-inline {
  width: 75px;
}

::v-deep .bxs-cloud-upload {
  color: #d3d3d3 !important;
}

* {
  font-family: "Noto Sans JP";
}

::placeholder {
  font-family: "Noto Sans JP";
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #d3d3d3 !important;
  opacity: 1; /* Firefox */
}

.text-button {
  font-weight: 700 !important;
}

::-webkit-input-placeholder {
  font-family: "Noto Sans JP";
  color: #d3d3d3 !important;
  opacity: 1; /* Firefox */
}

.text-table {
  font-weight: 400 !important;
  color: #404040;
}

::v-deep .btn-secondary {
  color: #65ace2 !important;
  border-color: #65ace2 !important;
  background: #ffffff !important;
}

.btn-lyg {
  color: #ffffff;
  background-color: #65ace2 !important;
  border-color: #65ace2 !important;
}

.text-label {
  font-weight: 500 !important;
  color: #404040;
}

.text-label-required {
  font-weight: 500 !important;
  color: #f5f5f5;
}

.bg-required-label {
  background: #ff5858 !important;
}

.text-label-filter {
  font-weight: 700 !important;
  color: #404040 !important;
}

.text-link {
  color: #336aff;
}

::v-deep .dropzone.dz-clickable {
  pointer-events: none;
  cursor: default;
}

.btn-capture {
  color: #ffffff !important;
  background-color: #395299 !important;
  border-color: #395299 !important;
}

.btn-capture:hover {
  background: #395299 !important;
}
</style>